import http, { API_CORE } from '../http';

export default function SellerImageService() {
  const getSellerImages = async (params = {}) => {
    const response = await http(API_CORE).get('/seller-images', {
      params: params,
    });
    return response.data;
  };

  const createSellerImage = async (input) => {
    const response = await http(API_CORE).post('/seller-images', input);
    return response.data;
  };
  const bulkCreateSellerImage = async (input) => {
    const response = await http(API_CORE).post('/seller-images/bulk', input);
    return response.data;
  };

  const deleteSellerImage = async (id) => {
    const response = await http(API_CORE).delete(`/seller-images/${id}`);
    return response.data;
  };

  const updateSellerImageOrdering = async (input) => {
    const response = await http(API_CORE).patch('/seller-images', input);
    return response.data;
  };

  return {
    getSellerImages: getSellerImages,
    createSellerImage: createSellerImage,
    bulkCreateSellerImage: bulkCreateSellerImage,
    deleteSellerImage: deleteSellerImage,
    updateSellerImageOrdering: updateSellerImageOrdering,
  };
}
